<template>
  <dialog-modal :show="isShow">
    <template #title>
      <div class="flex font-bold justify-center">
        ログイン
      </div>
    </template>
    <template #content>
      <div class="mx-auto flex justify-center">
        <div class="mx-auto">
          <div class="mb-5">オンライン模試と同じアカウントをご利用いただけます。</div>
          <form @submit.prevent="signIn">
            <label for="email">
              メールアドレス
            </label>
            <input
              v-model="email"
              class="block mt-2 mb-2 w-80 border-1 border-gray-500 rounded"
              type="email"
              required
              placeholder="メールアドレス"
              autocomplete="email" />
            <div
              v-if="emailFormErrorText"
              class="text-red-500 mb-5">
              ※{{ emailFormErrorText }}
            </div>

            <label for="password">
              パスワード
            </label>
            <input
              v-model="password"
              class="block mt-2 mb-2 w-80 border-1 border-gray-500 rounded"
              type="password"
              required
              placeholder="パスワード(6文字以上)"
              autocomplete="current-password" />
            <div
              v-if="passwordFormErrorText"
              class="text-red-500 mb-5">
              ※{{ passwordFormErrorText }}
            </div>
            <a
              href=""
              class="mb-5 flex justify-center underline text-blue-500 hover:underline"
              @click.prevent="$emit('reset-password')">
              パスワードを忘れた方はこちら
            </a>
            <div
              v-if="loginErrorText"
              class="whitespace-pre-line text-red-500 my-5">
              {{ loginErrorText }}
            </div>
            <button
              :disabled="isProcessing"
              class=" flex justify-self-end text-white text-center text-base bg-CLIENT_PRIMARY_PINK rounded-xl
                  mx-auto mt-2 px-10 py-2 hover:bg-CLIENT_PRIMARY_PINK_HOVER duration-500 disabled:bg-gray-300
                  disabled:cursor-not-allowed">
              ログイン
            </button>
          </form>
        </div>
      </div>
    </template>

    <template #footer>
      <button
        class="text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 ml-4 bg-white hover:bg-gray-100 duration-500"
        @click.prevent="$emit('close')">
        閉じる
      </button>
    </template>
  </dialog-modal>
</template>

<script setup>
import { ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import firebase from 'firebase/compat/app'
import DialogModal from '@/Common/DialogModal'
import firebaseApp from '@/Constants/configFirebase'
import 'firebase/compat/auth'
import { EmailRegex } from '@/Constants/regularExpression'
import SIGNIN_ERROR_MESSAGES from '@/Constants/signinErrors'
import {
  getAuth,
  signInWithEmailAndPassword,
} from 'firebase/auth'

const props = defineProps({
  isShow: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'reset-password'])

const auth = getAuth(firebaseApp)

const email = ref('')
const password = ref('')

const emailFormErrorText = ref('')
const passwordFormErrorText = ref('')
const loginErrorText = ref('')

const isProcessing = ref(false)

const isLoggedIn = ref(false)

const signIn = async () => {
  // 未入力＆フォーマットチェック
  if (!email.value.length) {
    emailFormErrorText.value = SIGNIN_ERROR_MESSAGES.emptyEmail
  } else if (!email.value.match(EmailRegex)) {
    emailFormErrorText.value = SIGNIN_ERROR_MESSAGES.invalidEmail
  } else {
    emailFormErrorText.value = ''
  }
  if (!password.value.length) {
    passwordFormErrorText.value = SIGNIN_ERROR_MESSAGES.emptyPassword
  } else {
    passwordFormErrorText.value = ''
  }

  // ERRORがあれば、処理を中断する
  if (emailFormErrorText.value || passwordFormErrorText.value) {
    return false
  }

  // 多重ポストを避ける
  if (isProcessing.value) return false
  isProcessing.value = true

  // firebase にログイン
  try {
    loginErrorText.value = ''
    await firebase.auth(firebaseApp).signInWithEmailAndPassword(email.value, password.value)

    // 正常系
    // uidを受け取れるトークンを取得
    const userToken = await firebase.auth(firebaseApp).currentUser.getIdToken(true)
    const userEmail = firebase.auth(firebaseApp).currentUser.email

    // Laravel側の認証
    Inertia.visit('/login', {
      method: 'post',
      data: {
        email: userEmail,
        password: password.value,
        idToken: userToken,
      },
    })
  } catch (err) {
    isProcessing.value = false

    // 異常系
    if (err.code === 'auth/user-not-found') {
      loginErrorText.value = 'ユーザーが存在しません。\n入力情報を再度ご確認ください。'
    }
    if (err.code === 'auth/wrong-password') {
      loginErrorText.value = 'パスワードに誤りがあります。\n入力情報を再度ご確認ください。'
    }
    return false
  }
  return false
}

</script>
